import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
import Modal from 'components/modal/modal';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
import QuestionMultipleChoiceOption from './question-multiple-choice-option';
import FilesComponent from 'components/files/files';
const QuestionMultipleChoice = ({ questionId, question, getRawAnswer, answers, onlyOnce, instructionsFile, getLocalAnswers }) => {
    const { t } = useTranslation();
    const [isDirt, setIsDirt] = useState(false);
    const [localAnswers, setLocalAnswers] = useState([]);
    const [modalContent, setModalContent] = useState();
    useEffect(() => {
        var _a;
        const aws = getRawAnswer(question);
        setLocalAnswers((_a = aws === null || aws === void 0 ? void 0 : aws.userAnswer) !== null && _a !== void 0 ? _a : []);
    }, [questionId]);
    const toggleCheck = (answerId) => {
        setIsDirt(true);
        if (!localAnswers.includes(answerId)) {
            if (onlyOnce) {
                setLocalAnswers([answerId]);
            }
            if (!onlyOnce) {
                setLocalAnswers([...localAnswers, answerId]);
            }
            return;
        }
        setLocalAnswers(localAnswers.filter(id => id !== answerId));
    };
    useEffect(() => {
        if (!isDirt) {
            return;
        }
        getLocalAnswers(localAnswers);
    }, [localAnswers]);
    return (_jsxs(_Fragment, { children: [modalContent && (_jsx(Modal, Object.assign({ title: question.title, close: () => setModalContent(undefined), footer: _jsxs(_Fragment, { children: [_jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline], title: t('GENERAL.CLOSE'), onClick: () => setModalContent(undefined) }, void 0), _jsx(Button, { title: localAnswers.includes(modalContent.id) ? t('QUESTION.MULTIPLE_CHOICE.UNSELECT_THIS_OPTION') : t('QUESTION.MULTIPLE_CHOICE.SELECT_THIS_OPTION'), onClick: () => {
                                toggleCheck(modalContent.id);
                                setModalContent(undefined);
                            } }, void 0)] }, void 0) }, { children: _jsx(RichTextViewer, { id: `modal-question-${question.id}-answer-${modalContent.id}`, content: modalContent.title }, void 0) }), void 0)), _jsx("form", Object.assign({ className: "form--student-exam form--with-image-selection" }, { children: answers.map(answer => (_jsx(QuestionMultipleChoiceOption, { questionId: question.id, answer: answer, onlyOnce: onlyOnce, localAnswers: localAnswers, setModalContent: setModalContent, toggleCheck: toggleCheck }, `question-${question.id}-answer-${answer.id}`))) }), void 0), instructionsFile && (_jsx(FilesComponent, { file: instructionsFile }, void 0))] }, void 0));
};
export default QuestionMultipleChoice;
